import React, { createContext, useState, useContext, useCallback, useMemo } from 'react';
import { adminLogin, adminLogout } from '../services/adminService';

const AdminAuthContext = createContext();

export const useAdminAuth = () => {
  return useContext(AdminAuthContext);
};

export const AdminAuthProvider = ({ children }) => {
  const [adminUser, setAdminUser] = useState(() => {
    try {
      const stored = localStorage.getItem('admin_user');
      return stored ? JSON.parse(stored) : null;
    } catch {
      localStorage.removeItem('admin_user');
      return null;
    }
  });
  const [loading, setLoading] = useState(false);

  const login = useCallback(async (email, password) => {
    setLoading(true);
    try {
      const response = await adminLogin(email, password);
      const data = await response.json();

      if (!response.ok) {
        return { 
          success: false, 
          message: data.error || 'Login failed' 
        };
      }

      if (data.user) {
        localStorage.setItem('admin_user', JSON.stringify(data.user));
        setAdminUser(data.user);
        return { success: true };
      }

      return { success: false, message: 'No user data received' };
    } catch (error) {
      console.error('Admin login error:', error);
      return { 
        success: false, 
        message: error.message || 'Login failed' 
      };
    } finally {
      setLoading(false);
    }
  }, []);

  const logout = useCallback(async () => {
    setLoading(true);
    try {
      await adminLogout();
    } catch (error) {
      console.error('Admin logout error:', error);
    } finally {
      localStorage.removeItem('admin_user');
      setAdminUser(null);
      setLoading(false);
    }
  }, []);

  const value = useMemo(() => ({
    adminUser,
    loading,
    login,
    logout
  }), [adminUser, loading, login, logout]);

  return (
    <AdminAuthContext.Provider value={value}>
      {children}
    </AdminAuthContext.Provider>
  );
};
